import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={11} height={12} xmlns="http://www.w3.org/2000/svg" style={{
    stroke: "none"
  }}><path d="M4.34.001v2.17H0V4.34h7.359c-.481.916-1.169 1.709-1.943 2.39-.517-.45-.96-.972-1.426-1.473l-1.6 1.469c.413.442.807.905 1.261 1.307-1.037.64-2.181 1.066-3.32 1.485l.76 2.032c1.507-.544 3.003-1.155 4.325-2.075 1.328.92 2.83 1.528 4.342 2.075l.76-2.032c-1.132-.414-2.266-.845-3.295-1.488 1.075-1.037 1.982-2.28 2.494-3.691h1.132v-2.17H6.51V0H4.34v.001z" /></svg>;
}
export default SvgComponent;